import { isExternalDomain } from '#src/lib/urls.ts';

import { useQueryString } from './useQueryString.ts';

export const useRedirectUrl = () => {
  const redirectUrl = decodeURIComponent(useQueryString('redirectUrl') || '');
  if (!redirectUrl || isExternalDomain(redirectUrl)) {
    return undefined;
  }
  try {
    const { pathname, search } = new URL(redirectUrl);
    return `${pathname}${search}`;
  } catch {
    return redirectUrl;
  }
};
